var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImagetypeAndLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1011.09 383.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Imagotipo en blanco") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_3",
    "data-name": "Capa 3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "314.16 170.69 153.67 186.13 300.38 119.26 279.26 82.69 148 176.31 241.62 45.05 205.05 23.93 129.37 189.98 129.37 193.62 205.05 359.67 241.62 338.55 148 207.29 279.26 300.91 300.38 264.34 153.67 197.47 314.16 212.91 314.16 170.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.37,206.71l-5.71,4.21-.35-.2a243.17,243.17,0,0,1-28.08,15.81A182.68,182.68,0,0,1,80.45,294,179.35,179.35,0,0,1,100,383.6h36.51A218.41,218.41,0,0,0,56.37,206.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.58,182.94a221.23,221.23,0,0,0,61.18-70.43l.81-1.51A219.48,219.48,0,0,0,136.47,0H100c3.13,64.49-30.9,128.57-86,162.49l.11,0L9.73,165l-1.3.75L8,166C5.34,167.51,2.68,169,0,170.3v40.1a218.24,218.24,0,0,0,47.24-26.48Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "513.65 249.24 472.09 249.24 472.09 200.06 507.34 200.06 507.34 179.73 472.09 179.73 472.09 133.96 513.05 133.96 513.05 113.23 448.65 113.23 448.65 269.97 513.65 269.97 513.65 249.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M721.66,270V181.33q0-12.51-12.72-12.51H670.18q-12.91,0-12.91,12.51v18.93H678V185.84h21.93v23.24H669q-12.91,0-12.92,12.51v36.46q0,12.31,12.52,12.32c8.25,0,26.21-5.1,31.15-6.87V270ZM678,252.54V224.6h21.93v27.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M627.42,168.42c-5.83,0-20.42,4.05-31.92,7.64q-2.1-7.63-11.94-7.64c-5.85,0-20.53,4.09-32,7.68v-7.28H528.58V270h22.93V188.34l21.54-.4v82h23V188.33l20.82-.39v82h23V180.73Q639.94,168.42,627.42,168.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M866.48,250l-21.53.4v-82h-23v89.23q0,12.32,12.52,12.32c5.85,0,20.53-4.09,32.05-7.69v7.29h22.93V168.42H866.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M805.59,270V180.73q0-12.31-12.52-12.31c-5.85,0-20.53,4.09-32.05,7.68v-7.28H738.09V270H761V188.34l21.53-.4v82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M958.41,168.82H918.86q-12.93,0-12.93,12.51v76.12q0,12.51,12.93,12.52h39.55q12.93,0,12.92-12.52V236.31H949.4v16.83H927.87V224.8h33.29l10.17-10.17v-33.3Q971.33,168.82,958.41,168.82Zm-9,41.05H927.87V185.64H949.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 988.56,
    y: 113.23,
    width: 22.53,
    height: 156.73
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagetypeAndLogo);
export default __webpack_public_path__ + "static/media/imagetype-and-logo.920a660640c191646ed748d1d497daad.svg";
export { ForwardRef as ReactComponent };